import { Component, OnInit, ViewChild, Input } from '@angular/core';

import {
  ChartComponent
} from "ng-apexcharts";
import { ControlVelocidadService } from 'src/app/services/flota/control-velocidad-service/control-velocidad.service';
import { ChartOptions } from 'chart.js';
import { Subscription } from 'rxjs';
import { ControlVelocidadGrafico } from 'src/app/models/flota-ctrlvelocidad-grafico.model';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'chart-barchart',
  templateUrl: './barchart.component.html',
  styleUrls: ['./barchart.component.scss']
})
export class BarChartComponent implements OnInit {

  // @Input() codequipo: string;
  // @Input() descripcion: string;
  // @Input() mdesde: string;
  // @Input() mhasta: string;
  @Input() movildata: any;

  @ViewChild("chart", { static: true }) chart: ChartComponent;
  public chartOptions: Partial<any>;

  info = [];
  fechasId = [];

  constructor(
    private gtp: Gtp
  ) {

  }

  ngOnInit() {
    //this.loadInforme();
    this.initChartData();
  }



  ifObjExist(fecha) {
    for (var i = 0; i < this.info.length; i++) {
      let infofecha = this.info[i].fecha.replace(/-|_/g, '');
      if (infofecha === fecha) {
        return i;
      }
    }
    return false;
  }

  loadInforme() {
    this.movildata.forEach((el, i) => {
      let tmp = new ControlVelocidadGrafico(el);
      let fechaPos = tmp.fecha.replace(/-|_/g, '');
      var idPos = this.fechasId.indexOf(fechaPos);
      if (idPos == -1) {
        this.fechasId.push(fechaPos);
        this.info.push({
          "name": tmp.fecha,
          "data": [tmp]
        });
      } else {
        this.info[idPos]['data'].push(tmp);
      }
    });
    if (this.info.length > 0) {
      this.initChartData();
    }
  }

  //https://apexcharts.com/docs/options/stroke/
  /*
  series: [
    {
      name: "02-11-2017",
      data: [
        {
          x: "02-11-2017 00:00:00",
          y: 34
        }     
      ]      
    }
  ],
  */
  public initChartData() {
    var $this = this;
    this.chartOptions = {
      series: this.movildata,
      chart: {
        height: 380,
        width: "100%",
        type: "bar",
        animations: {
          initialAnimation: {
            enabled: false
          }
        },
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          return val
        },
      },
      stroke: {
        curve: "straight"
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      xaxis: {
        type: 'time',
        labels: {
          rotate: -90,
          show: true,
          formatter: function (value, timestamp) {
            return $this.gtp.getHour(value, false) // The formatter function overrides format property
          },
        },
      }
    };
  }

}
